import { INVALID_VALUE } from './constants';

export function transformApiResponse(apiData) {
    if (!apiData || !apiData.Nodos) return [];
    const result = [];
    for (const nodo of apiData.Nodos) {
        if (!nodo.metricas || nodo.metricas.length === 0) continue;
        for (const m of nodo.metricas) {
            const ml = m.metricas_llamada || {};
            const txmos = parseFloat(ml.txmos);
            const rxjitter = parseFloat(ml.rxjitter);
            const txjitter = parseFloat(ml.txjitter);
            const lp = parseFloat(ml.lp);
            const rtt = parseFloat(ml.rtt);
            const rxmes = parseFloat(ml.rxmes);
            const txmes = parseFloat(ml.txmes);
            const rlp = parseFloat(ml.rlp);

            // Descartar registros sin datos válidos (todos en -1000)
            if (txmos === INVALID_VALUE && rxjitter === INVALID_VALUE) continue;

            result.push({
                timestamp: m.fecha,
                txmos: txmos === INVALID_VALUE ? null : txmos,
                jitter: rxjitter === INVALID_VALUE ? null : rxjitter,              // ya en ms
                txjitter: txjitter === INVALID_VALUE ? null : txjitter,            // ya en ms
                packetLoss: lp === INVALID_VALUE ? null : lp,                      // paquetes perdidos
                rtt: rtt === INVALID_VALUE ? null : rtt * 1000,                    // seg → ms
                rxmes: rxmes === INVALID_VALUE ? null : rxmes,                     // escala 0-100
                txmes: txmes === INVALID_VALUE ? null : txmes,                     // escala 0-100
                rlp: rlp === INVALID_VALUE ? null : rlp,                           // paquetes perdidos remoto
                nodo: nodo.nombre,
                nodoId: nodo.nodo_id,
                monitorId: nodo.monitor_id,
            });
        }
    }
    return result.sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));
}
